import Loader from "components/Loader";
import { useEffect, useState } from "react";
import RadioButton from "../RadioButton";
import TextBox from "../TextBox";
import { Button } from "../Button";
import ShoppingCartService from "../services/shopping-cart.service";
import { useErrorBoundary } from "basket/ErrorBoundary";
import { SupplyOwnFabric } from "../SupplyOwnFabric";
import ProductQtyInput from "components/ProductQtyInput";
import { OtherFabricSelector } from "../OtherFabricSelector";

export function BasketEditBedspreadsItem(props) {
    const { item, updateFabricItem, close } = props;
    const handleError = useErrorBoundary();
    const [linings, setLinings] = useState([]);
    const [formData, setFormData] = useState({
        measurement: 'cm',
        selectedLiningId: item.fabric.liningId,
        width: item.fabric.width,
        length: item.fabric.length,
        quantity: item.quantity,
        price: item.price,
        customization: item.fabric.customization,
        location: item.fabric.location,
        sessionId: item.productId,
        fabricId: item.fabricId,
        supplyOwnFabricNameOrDescription: item.supplyOwnFabricNameOrDescription,
        supplyOwnFabricRollWidth: item.supplyOwnFabricRollWidth,
        supplyOwnFabricPatternRepeat: item.supplyOwnFabricPatternRepeat
    });

    const [isSubmitDisabled, setSubmitDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [fabrics, setFabrics] = useState([])
    const [totalFabricsCount, setTotalFabricsCount] = useState(0)
    const [selectedFabric, setSelectedFabric] = useState(formData.fabricId)

    const [itemTitle, setItemTitle] = useState(`${item.fabric.fabricName} ${item.colour || ''} Fabric By ${item.fabric.supplierName || ''}`);;
    const title = () => `Edit Bedspreads In ${itemTitle}`;

    const handleInputChange = (field, value) => {

        if (field === 'width' && !value) { value = 0 }
        if (field === 'length' && !value) { value = 0 }

        setFormData((prevData) => {
            return {
                ...prevData,
                [field]: value,
            }
        });

        const validationError = validateInput(field, value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: validationError
        }));

        const hasErrors = Object.values({ ...errors, [field]: validationError }).some((error) => error);
        setSubmitDisabled(hasErrors);
    };

    const handleInputChangeUniversal = (e) => {        
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);

        const validationError = validateInput(name, value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: validationError
        }));

        const hasErrors = Object.values({ ...errors, [name]: validationError }).some((error) => error);
        setSubmitDisabled(hasErrors);
    };
    
    const validateInput = (name, value) => {
        let error = '';
        const num = Number(value);
        const errorMessage = "Invalid data";

        if (name === 'width') {
            if (!Number.isInteger(num) || num < 80 || num > 500) {
                error = errorMessage;
            }
        } else if (name === 'length') {
            if (!Number.isInteger(num) || num < 30 || num > 500) {
                error = errorMessage;
            }
        } else if (name === 'supplyOwnFabricPatternRepeat' || name === 'supplyOwnFabricRollWidth') {
            if (!Number.isInteger(num) || num <= 0 || num > 999) {
                error = errorMessage;
            }
        } else if (name === 'supplyOwnFabricNameOrDescription') {
            if (!value || value.trim() === '') {
                error = "This field is required";
            }
        }
        return error;
    };

    const handleQuantityChange = (value) => {
        if (value > 0 && value <= 100) {
            handleInputChange('quantity', value);
        }
    };

    const updatePrice = async () => {
        setSubmitDisabled(true);
        const response = await ShoppingCartService.create('price', {
            ...item,
            fabric: {
                fabricId: selectedFabric,
                liningId: formData.selectedLiningId,
                width: formData.width,
                length: formData.length,
                unitOfMeasurement: false,
                IsPiping: false,
                Location: formData.location,
                customization: formData.customization,
                quantity: formData.quantity,
            },
            supplyOwnFabricNameOrDescription: formData.supplyOwnFabricNameOrDescription,
            supplyOwnFabricPatternRepeat: formData.supplyOwnFabricPatternRepeat,
            supplyOwnFabricRollWidth: formData.supplyOwnFabricRollWidth
        }).catch(error => { handleError('Could not load item price. Please contact administrator'); });

        if (response){                
            setFormData((prevData) => {
                return {
                    ...prevData,
                    price: response.price * formData.quantity
                }
            });

            if (response.price > 0) {
                setSubmitDisabled(false);
            }
        }

    };

    const handleUpdate = async () => {
        setLoading(true);

        await updateFabricItem({
            ...item,
            fabricId: selectedFabric,
            fabric: {
                sessionId: formData.sessionId,
                fabricId: selectedFabric,
                liningId: formData.selectedLiningId,
                width: formData.width,
                length: formData.length,
                unitOfMeasurement: false,
                IsPiping: false,
                Location: formData.location,
                customization: formData.customization,
                quantity: formData.quantity,
            },
            supplyOwnFabricNameOrDescription: formData.supplyOwnFabricNameOrDescription,
            supplyOwnFabricPatternRepeat: formData.supplyOwnFabricPatternRepeat,
            supplyOwnFabricRollWidth: formData.supplyOwnFabricRollWidth
        });

        setLoading(false);
    }

    const fetchLinings = async () => {
        const response = await ShoppingCartService.get('linings?liningFor=4&liningType=1')
            .catch(error => { handleError('Could not load item details. Please contact administrator'); });
        if(response) setLinings(response);
    };

    const loadFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId)
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const loadAllFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId + '&showAll=true')
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    useEffect(() => {
        fetchLinings();
        loadFabrics();
    }, []);

    useEffect(() => {
        updatePrice();
    }, [formData.measurement, formData.length, formData.width, formData.selectedLiningId, formData.quantity]);

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabric);
        if (foundFabric){                    
            setItemTitle(foundFabric.fullName);
            updatePrice();
        }
    }, [selectedFabric]);

    return (
        <Loader isLoading={isLoading}>
            <form className="p-32 pb-54 bg3 measurements-change active-group sm-p-20">
                <div className="row">
                    <div className="col">
                        <div className="subtitle1 mb-16 sm-text-24">{title()}</div>
                    </div>
                    <div className="col-auto">
                        <span 
                            className="curtains-icon curtains-icon-close size-24 show-btn hide-btn"
                            onClick={() => close()}></span>
                    </div>
                </div>

                {
                    item.supplyOwnFabric && (
                        <SupplyOwnFabric fabricData={formData} setFabricData={setFormData} errors={errors} handleInputChange={handleInputChangeUniversal} />
                    )
                }

                <OtherFabricSelector fabrics={fabrics} totalFabricsCount={totalFabricsCount} loadAllFabrics={loadAllFabrics} selectedFabric={selectedFabric} setSelectedFabric={setSelectedFabric} />

                <div>
                    <div className="body-text3 gray mb-8">Measurements:</div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="measurements"
                            label={'cm'}
                            value={0}
                            checked={formData.measurement === 'cm'}
                            onChange={() => handleInputChange('measurement', 'cm')}
                        />
                        <RadioButton
                            name="measurements"
                            label={'inches'}
                            value={1}
                            checked={formData.measurement === 'inches'}
                            onChange={() => handleInputChange('measurement', 'inches')}
                        />
                    </div>
                </div>

                <div className="d-flex gap-40 mb-16 sm-gap-16">
                    <div className="max-width-215">
                        <div className="body-text3 mb-8">Width</div>
                        <TextBox
                            name="width"
                            value={formData.width}
                            unit={formData.measurement}
                            onChange={(e) => handleInputChange('width', e.target.value)}
                        />
                        {errors.width && (
                            <span className="field-validation-error">{errors.width}</span>
                        )}
                    </div>
                    <div className="max-width-215">
                        <div className="body-text3 mb-8">Length</div>
                        <TextBox
                            name="length"
                            value={formData.length}
                            unit={formData.measurement}
                            onChange={(e) => handleInputChange('length', e.target.value)}
                        />
                        {errors.length && (
                            <span className="field-validation-error">{errors.length}</span>
                        )}
                    </div>
                </div>
                
                <div className="body-text3 gray mb-8">Lining:</div>
                <div className="d-flex gap-32 mb-16 have-first-el-checked sm-two-columns">
                    {linings.map((lining) => (
                        <RadioButton
                            name="Lining"
                            label={lining.name}
                            value={lining.id}
                            checked={formData.selectedLiningId === lining.id}
                            onChange={() => handleInputChange('selectedLiningId', lining.id)}
                            key={lining.id}
                        />
                    ))}
                </div>
                <hr className="secondary-line mb-16"></hr>

                {/* Customization Section */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Bedspread Customisation:</div>
                    <div className="max-width-410 mb-16 sm-text-14">If you have special requests, write below or <a href="/contact-us" className="underline">contact us</a> <a href="tel:0345 8620743" className="underline">0345 8620743</a></div>
                    <div className="mb-16">
                        <TextBox
                            name="Customization"
                            value={formData.customization}
                            placeholder="e.g. Trim or borders"
                            onChange={(e) => handleInputChange('customization', e.target.value)}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Location Section */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Bedspread location:</div>
                    <div className="max-width-410 mb-16 sm-text-14">Let us know where your bedspread will be used, and we will include this in your order details for you. (Optional).</div>
                    <div className="mb-16">
                        <TextBox
                            name="Location"
                            value={formData.location}
                            placeholder="e.g. Dining room large window"
                            onChange={(e) => handleInputChange('location', e.target.value)}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Total Price and Quantity */}
                <div>
                    <div className="subtitle2 mb-8 mt-16">TOTAL: <span className="body-text1">£{formData.price}</span></div>
                    <div className="body-text6">Delivery for made-to-measure curtains: 2-4 weeks.</div>
                </div>

                <div className="mb-16 mt-32" id="updateProductQuantity">
                    <div className="dashed-line mb-24"></div>
                    <div className="body-text3 gray mb-16">Quantity:</div>

                    <ProductQtyInput initValue={formData.quantity} onlyInt={true} onChange={handleQuantityChange} />
                </div>

                <div className="d-flex gap-16 mb-16 sm-column sm-gap-8 sm-mb-0">
                    <div className="w-100 show-btn hide-btn">
                        <Button name="UPDATE" onClick={() => handleUpdate()} disabled={isSubmitDisabled} />
                    </div>
                </div>
            </form>
        </Loader>
    );
}
